import * as styles from "@/features/search/components/Results/Results.module.scss";
import React from "react";
import type { HighlightResultNormalised } from "./types";
import { getNextHighlight } from "./helpers";
import { Highlight } from "./Highlight";

export const NextHighlight = ({
  highlights,
  ignore = [],
  sport,
}: {
  highlights: null | HighlightResultNormalised;
  ignore?: string[];
  sport?: string;
}) => {
  // get the next highlight, ignore the ones we are already displaying
  const [highlight, highlightTitle] = getNextHighlight(
    highlights,
    ignore,
    sport,
  );

  const isSport = highlightTitle === "Sport: ";
  const isEvent = highlightTitle === "Event: ";
  // sport can have underscores and all caps, we want to remove the underscores and convert to title case (AGE_OF_EMPIRES -> Age of Empires)
  const html =
    highlight &&
    highlight.matchedWords &&
    (isSport ? highlight.value.replace(/_/g, " ") : highlight.value);

  return html ? (
    <div className={styles.highlightRow}>
      {highlightTitle}
      <Highlight
        matchedWords={highlight.matchedWords}
        html={html}
        convertToTitleCase={isSport || isEvent}
      />
    </div>
  ) : null;
};
